import React from 'react'
import {Row, Col} from 'react-bootstrap';

const FileUploadSuccess = () => {
    return (
        <>
        <Row>
            <Col>
                <span>Thank you for submitting your file upload. You should have recieved a confirmation email.
                    You will recieve an addition email once your file has been reviewed.</span>
            </Col>
        </Row>
        </>
    )
}

export default FileUploadSuccess;